import React from "react"

export default class extends React.Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	componentDidMount() {
		const { token, src, type } = this.props

		const method = "GET"
		const authorization = `Bearer ${token}`
        const mode = 'no-cors';
		const headers = new Headers({ authorization, type })
		const options = { method, headers , mode }

		fetch(src, options)
			.then(response => {
                console.log('::::::::::::::::We got response');
                console.log(response);
                
                return response.blob()})
			.then(response => {
                console.log('::::::::::::::::::::::::::Auth IFrame ::: Got Valid response')
				var blob = new Blob([response], { type })
				const obj = URL.createObjectURL(blob)
				this.setState({ blobObject: obj })
			})
			.catch(e => console.error("::::::::::::::::::::::::::::::Auth IFrame ::::::::Error", e))
	}

	render() {
		const { src, token, ...props } = this.props

		return <iframe src={this.state.blobObject} {...props} />
	}
}
